/*!
 * jqtimeline Plugin
 * http://goto.io/jqtimeline
 * https://github.com/ozeetee/jqtimeline
 *
 * Copyright 2013 goto.io
 * Released under the MIT license
 *
 */


(function($) {
	var pluginName = 'jqTimeline';
	var defaults = {
	                showTooltip           : true,
	                canZoomIn             : false,
	                isZoomedIn            : false,
	                includeDateInTooltip  : false,
	                includeTitleInTooltip : true,
	                totalWidth            : 960,
	                groupEventWithinPx    : 6, // Will show common tooltip for events within this range of px
	                events                : [],
	                originalEvents        : [],
	                click                 : null, //Handler for click event for event
	                language              : 'nl'
	               };
	var aMonthsEnglish = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	var aMonthsDutch   = ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'];
	var limitToShowAllMonthsLabel = 11; //months
	var limitToShowAllMonthsSeparator = 18; //months
	var limitToShowQuarterLabel = 48; //months
	var limitToShowQuarterSeparator = 72; //months
	var limitToShowYearLabel = 10; //years
	var limitToShowYearSeparator = 10; //years
	var limitMaxDaysForSpanInDays = 150; //days
	var maxDaysInMonth = 31;

	function jqTimeLine(element, options) {
		this.options = $.extend({}, defaults, options);

		this.$el = $(element);
		this._defaults = defaults;
		this._name = pluginName;

		var startingDate = this._getStartingDate();
		var endingDate = this._getEndingDate();

		this._startYear = startingDate.getFullYear();
		this._endYear   = endingDate.getFullYear();

		this._startMonth = startingDate.getMonth();
		this._endMonth   = endingDate.getMonth();

		this._startDayOfMonth = startingDate.getDate();
		this._endDayOfMonth   = endingDate.getDate();

		this._diffYears = this._endYear - this._startYear;
		this._totalNumYears  = this._diffYears + 1;

		this._monthsFirstYear = (11 - this._startMonth) + 1; // plus 1 because months of one year go from 0 to 11
		this._monthsLastYear = this._endMonth + 1; // plus 1 because  months of one year go from 0 to 11
		this._totalMonths = this._getTotalMonths(); // uses _totalNumYears

		this._aproxTotalDays = (maxDaysInMonth * this._totalMonths) - 
		                       this._startDayOfMonth -
		                       (maxDaysInMonth - this._endDayOfMonth) + 1;

		this._aproxTotalHours = this._aproxTotalDays * 24;

		this._aproxTotalMinutes = this._aproxTotalHours * 60;

		this._aMonthsLabels = ((this.options.language == 'nl') ? aMonthsDutch : aMonthsEnglish);


		
		if (this.options.isZoomedIn) {
			this._offset_x = 16 + 30; // Starting position of the line (space to show the year/month)
			this._current_offset_x = 16 + 30; // used for laying out months to the horizontal line
			this._mainLineWidth = this.options.totalWidth - (2*this._offset_x) - 30;
		} else {
			this._offset_x = 16; // Starting position of the line (space to show the year/month)
			this._current_offset_x = 16; // var used for laying out months to the horizontal line
			this._mainLineWidth = this.options.totalWidth - (2*this._offset_x);
		}

		this._gapBetweenMonths = this._mainLineWidth / this._totalMonths; // gap between months
		this._gapBetweenDays = this._mainLineWidth / this._aproxTotalDays; // gap between days
		this._gapBetweenHours = this._mainLineWidth / this._aproxTotalHours;
		this._gapBetweenMinutes = this._mainLineWidth / this._aproxTotalMinutes;
		
		this._eDotWidth = 16; // Width of the event dot shown in the ui
		this._$tooltip = null; // use to have reference of the tooltip
		this._a$Events = []; // will store all jquery elements of events, marked on the timeline
		this._aEvents = []; //array of events obj {id,name,on}
		this._counter = 0; // Use to generate id for events without ids
		this.$mainContainer;
		
		this._aNeighborEvents = []; // will store neighbor events that can be zoomed in (see groupEventWithinPx)
		
		this.init();

	}

	jqTimeLine.prototype._getTotalMonths = function() {

		var numberMonths;
		if (this._totalNumYears > 2) {
			numberMonths = this._monthsFirstYear + ((this._totalNumYears - 2) * 12) + this._monthsLastYear; //don't add
			// 1 because _monthsFirstYears and _monthsLastYears go from 1 to 12 already
		} else if (this._totalNumYears == 2) {
			numberMonths = this._monthsFirstYear + this._monthsLastYear; // don't add 1 because _monthsFirstYears
			                                                             // and _monthsLastYears go from 1 to 12 already
		} else if (this._totalNumYears == 1) {
			numberMonths = (this._endMonth - this._startMonth) + 1; //plus 1 because months of one year go from 0 to 11
		}

		return numberMonths;

	};


	jqTimeLine.prototype._getEndingDate = function() {

		var mostRecentDate = new Date('1800');

		$.each(this.options.events,function(key, event) {
		
			var currentDate = event.on;
			if (currentDate > mostRecentDate) {
				mostRecentDate = currentDate;
			}
		});
		
		return mostRecentDate;
	};


	jqTimeLine.prototype._getStartingDate = function() {

		var earliestDate = new Date('2100');

		// avoid for(var k in array) : order of iteration is not guaranteed and inherited properties are also enumerated
		$.each(this.options.events,function(key, event) {
			
			var currentDate = event.on;
			if (currentDate < earliestDate) {
				earliestDate = currentDate;
			}
		});

		return earliestDate;
	};

	jqTimeLine.prototype.init = function() {
		var _this = this;

		this._generateMarkup();
		//Attach a event handler to global container
		if(_this.options.click){
			_this.$mainContainer.on('click',function(e){
				var $t = $(e.target);
				if($t.hasClass('event') || $t.hasClass('msg')){
					//In both the cases eventId is stored in the format msg_eventid or event_eventid
					var eventId = $t.attr('id').split("_")[1];
					_this.options.click(e,_this._aEvents[eventId]);
				}
				if($t.hasClass('closeTooltip')){
					//we may need to close the tooltip
					var eventId = $t.attr('id').split("_")[1];
					var $tgt = $('#'+eventId);
					_this._addEventListner($tgt,'mouseleave');
					var $tooltipEl = $('#tooltip_' + eventId);
					$tooltipEl.remove();
				}
			});
		}
		
		// Restore the original timeline from 'isZoomedIn' state
		$(document).on('click','.gt-timeline .navBack', function(e) {
			$(_this.$el).empty();
			$(_this.$el).jqtimeline({
			                         events               : _this.options.originalEvents,
			                         canZoomIn            : true,
			                         totalWidth           : _this.options.totalWidth,
			                         includeDateInTooltip : true,
			                         bottom               : _this.options.bottom, // for DOT
			                         click                : _this.options.click
			});
		});
	};

	jqTimeLine.prototype._generateMarkup = function() {
		var _this = this;
		
		var borderWidthLastSeparator = (_this._endMonth == 11) ? 3 : 1; // linked to .horizontal-line & .month-line

		var mainLineWidth = _this._mainLineWidth + borderWidthLastSeparator;

		var htmlContainer = "<div class='gt-timeline'" + "style='width:"+_this.options.totalWidth+"px;";
		
		// _this.options.bottom is used in DOT to make sure the timeline is positioned right above the
		// SVG Player Controller using the CSS 'bottom' property.
		// Only add bottom to style if its defined
		(_this.options.bottom) ? htmlContainer += "bottom:"+ _this.options.bottom + "px;'>" : htmlContainer += "'>";

		if (_this.options.isZoomedIn) {
			htmlContainer = htmlContainer + "<div class='navBack'>" +
			                "<div class='arrowBack'></div>" +
			                "</div>";
		}
		htmlContainer = htmlContainer + 
		                "<div class='main_line' style='width:"+mainLineWidth+"px;left:"+_this._offset_x+"px'>" +
		                "</div>" +
		                "</div>";

		var $mainContainer = this.$mainContainer = $(htmlContainer);

		var i = 0, j = 0;

		// Add lines/labels to define the period
		if (_this._aproxTotalDays <= limitMaxDaysForSpanInDays) {
			//when minimum period is one day
			var tempMonth = _this._startMonth;
			var tempYear = _this._startYear;
			for(j=0;j<_this._totalMonths;j++){
				// first month of total period
				if (j == 0) {
					var lastDayFirstMonth = (_this._totalMonths == 1) ?
					                                            _this._endDayOfMonth+1 : //+ 1 to draw end of the line
					                                            maxDaysInMonth;
					for(i=_this._startDayOfMonth; i<=lastDayFirstMonth;i++) {
						$mainContainer.append(_this._getDayMarkup(i,_this._startMonth,_this._startYear,'first'));
					}
				// last month of total period
				} else if (j == _this._totalMonths - 1) {
					for(i=1;i<=_this._endDayOfMonth+1;i++) { //._endDayOfMonth + 1 to draw the end of the line
						$mainContainer.append(_this._getDayMarkup(i,_this._endMonth,_this._endYear,'last'));
					}
				// months in between
				} else {
					tempMonth++;
					if (tempMonth > 11) {
						tempYear++;
						tempMonth = 0;
					}
					for(i=1;i<=maxDaysInMonth;i++){
						$mainContainer.append(_this._getDayMarkup(i,tempMonth, tempYear,'middle'));
					}
				}
			}
		} else {
			//when minimum period is one month
			for(j=0;j<_this._totalNumYears;j++){
				// first year of total period
				if (j == 0) {
					var lastMonthFirstYear = (_this._totalNumYears == 1) ? _this._endMonth+1 : 11;//_endMonth + 1 to draw
					                                                                              //the end of the line
					for(i=_this._startMonth; i<=lastMonthFirstYear;i++) {
						$mainContainer.append(_this._getMonthMarkup(i,_this._startYear));
					}
				// last year of total period
				} else if (j == _this._totalNumYears - 1) {
					for(i=0;i<=_this._endMonth+1;i++) { //_endMonth (0 to 11) + 1 to draw the end of the line
						$mainContainer.append(_this._getMonthMarkup(i,_this._endYear));
					}
				// years in between
				} else {
					for(i=0;i<12;i++){
						$mainContainer.append(_this._getMonthMarkup(i,_this._startYear + j));
					}
				}
			}
		}

		// Add events
		for(var k in _this.options.events){
			var e = _this.options.events[k];
			var d = e.on;
			if(d.getFullYear() >= _this._startYear && d.getFullYear() < _this._startYear + _this._totalNumYears){
				$mainContainer.append(_this._getEventMarkup(e));
			}
		}

		_this.$el.append($mainContainer);
	};

	jqTimeLine.prototype._getDayMarkup = function(day,month,year,positionMonth){
		var _this = this;
		var retStr = "";
		
		if (day == _this._startDayOfMonth && positionMonth == 'first') {
			// starting point of timeline
			retStr ="<div class='horizontal-line month-line start-month' style='left:"+_this._current_offset_x+"px'>";
			retStr = retStr + "<div class='year'>"+year+"</div>" +
			         "<div class='month'>"+_this._aMonthsLabels[month]+" "+day+"</div></div>";
		} else if (day == _this._endDayOfMonth + 1 && month == _this._endMonth && 
		           (positionMonth == 'first' || positionMonth == 'last')) {
			// ending point
			retStr ="<div class='horizontal-line day-line' style='left:"+_this._current_offset_x+"px'>";
			if (day <= maxDaysInMonth) {
				retStr = retStr + "<div class='day'>"+day+"</div>";
			}
			retStr = retStr + "</div>";
		} else if (day == 1) {
			// mark the beginning of a month
			retStr ="<div class='horizontal-line month-line start-month' style='left:"+_this._current_offset_x+"px'>";
			// show year if required
			retStr = retStr + "<div class='year'>";
			if (month == 0 && year > _this._startYear) {
				retStr = retStr + year;
			} else {
				retStr = retStr + '&nbsp;';
			}
			retStr = retStr + "</div>";
			retStr = retStr + "<div class='month'>"+_this._aMonthsLabels[month]+"</div></div>";
		}
		
		_this._current_offset_x += _this._gapBetweenDays;
		return retStr;
	};

	jqTimeLine.prototype._getMonthMarkup = function(month,year){
		var _this = this;
		var retStr = "";
		if(month== 0){
			// print year (not the month) if timeline starts on january
			if (_this._totalNumYears < limitToShowYearSeparator || year == _this._startYear || year == _this._endYear){
				retStr = '<div class="horizontal-line line-year" style="left:'+_this._current_offset_x+'px">';

				if (_this._totalNumYears < limitToShowYearLabel || year == _this._startYear ||
				    (year == _this._endYear && _this._endMonth != 11) ){
					retStr = retStr + '<div class="year">'+year+'</div>';
				}
				retStr = retStr + '</div>';
			}
		} else if (_this._startMonth != 0 && month == _this._startMonth && year == _this._startYear) {
			// print year and month when timeline starts on a month different than january
			retStr='<div class="horizontal-line month-line start-month" style="left:'+_this._current_offset_x+'px">' + 
			           "<div class='year'>"+year+"</div>" +
			           "<div class='month'>"+_this._aMonthsLabels[month]+"</div>" +
			       '</div>';
		} else if(month== 12 && year == _this._endYear && this._endMonth == 11){
			// show next year at the end of line when last event occurs in december
			retStr='<div class="horizontal-line line-year rightend" style="left:'+_this._current_offset_x+'px">' + 
			           '<div class="year">'+(year+1)+'</div>' +
			       '</div>';
		} else if(month%3 != 0){
			// handle non-quarter months.

			// show next month at the end of the line, except when _totalNumYears > limitToShowYearSeparator
			var isClosingElement = false;
			if (_this._totalNumYears < limitToShowYearSeparator) {
				isClosingElement = (month == _this._endMonth + 1 && year == _this._endYear);
			}
			
			if (_this._totalMonths <= limitToShowAllMonthsSeparator || isClosingElement) {

				retStr='<div class="horizontal-line month-line" style="left:'+_this._current_offset_x+'px">';
		
				if (_this._totalMonths <= limitToShowAllMonthsLabel || isClosingElement) {
					retStr = retStr + '<div class="month">'+_this._aMonthsLabels[month]+'</div>';
				}
				retStr= retStr+'</div>';
			}
		} else {
			// quarters of year
			if (_this._totalMonths <= limitToShowQuarterSeparator) {

				retStr = '<div class="horizontal-line month-line" style="left:'+_this._current_offset_x+'px">';

				if (_this._totalMonths <= limitToShowQuarterLabel) {
					retStr = retStr + '<div class="month">'+_this._aMonthsLabels[month]+'</div>';
				}

				retStr = retStr + '</div>';
			}
		}
		_this._current_offset_x += _this._gapBetweenMonths;
		return retStr;
	};

	jqTimeLine.prototype._getEventMarkup = function(e){
		var _this = this;
		//Attach id if not there
		if(typeof e.id === 'undefined') e.id = _this._getGenId();
		_this._aEvents[e.id] = e; //Add event to event array
		var eName = e.name;
		var d = e.on;
		var n = d.getDate();
		var yn = d.getFullYear();
		var month = d.getMonth();
		var hour = d.getHours();
		var minu = d.getMinutes();

		var leftVal; //used to determine the location of the event on the line

		if (_this._aproxTotalDays <= limitMaxDaysForSpanInDays) {
			var dayPosition;
			var monthOffset;
			if (month == _this._startMonth && yn == _this._startYear) {
				// first month
				dayPosition = n - _this._startDayOfMonth;
			} else {
				// rest of months
				monthOffset = (yn - _this._startYear) * 12 + (month - _this._startMonth) - 1; //
				
				dayPosition = (maxDaysInMonth - _this._startDayOfMonth) + 1 +
				              (monthOffset * maxDaysInMonth) +
				              n -1;
			}

			leftVal = Math.ceil(_this._offset_x + 
			                    (dayPosition * _this._gapBetweenDays) +
			                    (hour * _this._gapBetweenHours) +
			                    (minu * _this._gapBetweenMinutes) - 
			                    _this._eDotWidth/2);

		} else {
			var monthPosition;
			if (yn == _this._startYear) {
				monthPosition = month - _this._startMonth;
			} else if (yn == _this._endYear) {
				if (this._totalNumYears > 2) {
					monthPosition = _this._monthsFirstYear + ((this._totalNumYears - 2) * 12) + month;
				} else {
					monthPosition = _this._monthsFirstYear + month;
				}
			} else {
				var positionOfYear = yn - _this._startYear;
				monthPosition = _this._monthsFirstYear + ((positionOfYear - 1) * 12) + month;
			}

			leftVal = Math.ceil(_this._offset_x + (monthPosition * _this._gapBetweenMonths) +
			                    (_this._gapBetweenMonths/maxDaysInMonth)*n - _this._eDotWidth/2);
		}
		
		var $retHtml = $('<div class="event" id="event_'+e.id+'" style="left:'+leftVal+'px">&nbsp;</div>').data('event',e);
		$retHtml.data('eventInfo',_this._aEvents[e.id]);
		if(_this.options.click){
			_this._addEventListner($retHtml,'click');
		}
		if(_this.options.showTooltip){
			_this._addEventListner($retHtml,'mouseover');
			_this._addEventListner($retHtml,'mouseleave');
		}
		_this._a$Events[e.id] = $retHtml;
		return $retHtml;
	};


	jqTimeLine.prototype._getGenId = function(){
		var _this = this;
		while(_this._counter in this._aEvents){
			_this._counter ++;
		}
		return _this._counter;
	};

	jqTimeLine.prototype._showTooltip=function(nLeft,strTooltip,eventId){
		var _this = this;
		// the tooltips located close to the right side need some offset
		var offsetTooltip = nLeft;
		var minWidthTooltip = "";
		if (this.options.totalWidth - nLeft < 100) {
			offsetTooltip = nLeft - 100;
			minWidthTooltip = "min-width:115px;";
		}
		
		_this._$tooltip  = $('<div class="message-pointer" id="pointer_'+eventId+'" style="left:'+nLeft+'px;"></div>' +
		                     '<div class="e-message" id="tooltip_'+eventId+
		                     '" style="left:'+ offsetTooltip +'px;z-index:1;'+minWidthTooltip+'">' +
		                     strTooltip + 
		                     '</div>');
		_this.$mainContainer.append(_this._$tooltip);
	};

	jqTimeLine.prototype._getAllNeighborEvents = function(nLeft){
		var _this = this;
		//Get all events that are within the range specified in the options
		var neighborEvents = $('.event',_this.$mainContainer).filter(function(){
			var nCurrentElLeftVal = parseInt($(this).css('left'));
			return (nCurrentElLeftVal <= nLeft +  _this.options.groupEventWithinPx) && (nCurrentElLeftVal >= nLeft -  _this.options.groupEventWithinPx);
		});
		
		return neighborEvents;
	};

	jqTimeLine.prototype._addEventListner = function($retHtml,sEvent){
		var _this = this;
		if(sEvent == 'mouseover'){
			
			_this._aNeighborEvents = [];
			
			$retHtml.mouseover( 
				function(e){
					var $t = $(e.target);
					var nLeft = parseInt($t.css('left'));
					var eObj = $t.data('event');
					if(_this._$tooltip){
						if(_this._$tooltip.data('state') && _this._$tooltip.data('state') === 'static'){
							var eventId = _this._$tooltip.data('eventId');
							var $tgt = $('#'+eventId);
							// _this._addEventListner($tgt,'mouseover');
							_this._addEventListner($tgt,'mouseleave');
							_this._$tooltip.data('state','dynamic');
						}
						_this._$tooltip.remove();
					}

					var neighborEvents = _this._getAllNeighborEvents(nLeft);
					
					var neighborEventsLength = neighborEvents.length;
					var strTooltip = "";
					for(var i = 0; i < neighborEventsLength; i++) {
						var $temp = $(neighborEvents[i]);
						var oData = $temp.data('event');
						
						_this._aNeighborEvents[i] = _this._aEvents[oData.id];//'zoom in' to these events on click
						
						if ( (_this.options.includeDateInTooltip && oData.on != '') || 
						     (_this.options.includeTitleInTooltip && oData.name) ) {

							strTooltip = strTooltip + '<div class="msg" id="msg_'+oData.id+'">';

							if (_this.options.includeDateInTooltip) {
								strTooltip = strTooltip + oData.on.toLocaleString();
								if (_this.options.includeTitleInTooltip) {
									strTooltip = strTooltip + ' : ';
								}
							}
							if (_this.options.includeTitleInTooltip) {
								strTooltip = strTooltip + oData.name;
							}
							strTooltip = strTooltip + '</div>';
						}
					}
					_this._showTooltip(nLeft,strTooltip,eObj.id);
				}
			);
		}
		if(sEvent == 'mouseleave'){
			$retHtml.mouseleave(function(e){
				_this._aNeighborEvents = []; // clear 'zoom in' array
				var $targetObj = $(this);
				var eventId = $targetObj.data('event').id;
				var $tooltipEl = $('#tooltip_' + eventId);
				var $tooltipPointerEl = $('#pointer_' + eventId);
				e.stopImmediatePropagation();
				var fixed = setTimeout(function(){
					$tooltipEl.remove();
					$tooltipPointerEl.remove();
				}, 500);
				$tooltipEl.hover(
					function(){
						clearTimeout (fixed);
					},
					function(){
						$tooltipEl.remove();
						$tooltipPointerEl.remove();
					}
				);
			});
		}
		if(sEvent == 'click'){
		// Attach a click event handler to event objects
			$retHtml.click(function(e){
				var $targetObj = $(this);
				var eventId = $targetObj.data('event').id;
				
				var $tooltipEl = $('#tooltip_' + eventId);
				var $msgs = $('.msg',$tooltipEl);
				if($msgs.length == 1){
					// Do not stop the propagation: Let the parent handle the click event
					//_this.options.click();
				}else if($msgs.length > 1){
					
					if (_this.options.canZoomIn) {
						$(_this.$el).empty();
						$(_this.$el).jqtimeline({
						                         events               : _this._aNeighborEvents,
						                         originalEvents       : _this.options.events,
						                         isZoomedIn           : true,
						                         totalWidth           : _this.options.totalWidth,
						                         includeDateInTooltip : true,
						                         bottom               : _this.options.bottom, // for DOT
						                         click                : _this.options.click
						});
					}
					
					// If the tooltip has more than one message make it non-dynamic
					// e.stopPropagation(); // Stop the propagation so that the parent wont get notified
					// var markup = $('<div class="info"><div>Select one even from below:</div>' +
					//              '<div class="icon-close closeTooltip" id="eCloseButton_'+eventId+'"></div>' +
					//              '</div>');
					// $tooltipEl.prepend(markup);
					// $retHtml.off('mouseover');
					$retHtml.off('mouseleave');
					$tooltipEl.data('state','static');
					$tooltipEl.data('eventId',eventId);
				}
			});
		}
	};


	var isArray = function(a){
		return Object.prototype.toString.apply(a) === '[object Array]';
	};

	// public methods start from here
	jqTimeLine.prototype.addEvent = function(e){
		var arr = [],i=0;
		arr = $.isArray(e) ? e : [e];
		var arrLength = arr.length;

		for(i = 0; i < arrLength; i++) {
			var markup = this._getEventMarkup(arr[i]);
			this.$mainContainer.append(markup);
		}
	};

	jqTimeLine.prototype.deleteEvent = function(eIds){
		var _this = this;
		if(typeof eIds === 'undefined') return;
		var arr = [],i;
		if(typeof eIds === "number" || typeof eIds === "string"){
			arr = [eIds]; // ids can be string too
		}else if (isArray(eIds)){
			arr = eIds; // This can be array of objects
		}else{
			arr = [eIds];// This can be object itself
		}
		var arrLength = arr.length;

		for(i = 0; i < arrLength; i++) {
			var key = arr[i]; // This can be a event object itself
			if(typeof key === 'object'){
				if(typeof key.id === 'undefined') {
					continue;
				} else {
					key = key.id;
				}
			}
			var $obj = _this._a$Events[key];
			if(typeof $obj === 'undefined') continue;
			$obj.remove();
			delete _this._a$Events[key];
			delete _this._aEvents[key]; 
		}
	};

	jqTimeLine.prototype.getAllEvents = function(){
		var _this = this;
		var retArr = [];
		for(var key in _this._aEvents){
			retArr.push(_this._aEvents[key]);
		}
		return retArr;
	};

	jqTimeLine.prototype.getAllEventsElements = function(){
		var _this = this;
		var retArr = [];
		for(var key in _this._a$Events){
			retArr.push(_this._a$Events[key]);
		}
		return this._a$Events;
	};

	$.fn.jqtimeline = function(options) {
		return this.each(function() {
			var element = $(this);
			if(element.data('timeline')) return;
			var timeline = new jqTimeLine(this, options);
			element.data('jqtimeline', timeline);
		});
	};

}(jQuery, window));
// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
